import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import ResetPassword from './views/ResetPassword.vue'
import Restricted from "./views/Restricted.vue"
import Deactivate from "./views/Deactivate.vue"
import Addin from "./views/Addin.vue"
import Cookies from 'js-cookie'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      redirect: { name: 'Login'}
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    }, {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
    }, {
      path: '/restricted',
      name: 'Restricted',
      component: Restricted
    }, {
      path: '/deactivate',
      name: 'Deactivate',
      component: Deactivate
    }, {
      path: '/addin',
      name: 'Addin',
      component: Addin
    }, {
      path: '/logout',
      name: 'Logout',
      beforeEnter: (to, from, next)=>{
        Cookies.remove("redirectUrl")
        Cookies.remove("redirectUrlV2")
        next('/login')
      }
    },
  ],
});

export default router;

router.beforeEach((to, from, next) => {
  if (to.hash.startsWith('#/')) {
    const path = to.hash.substring(2);
    next(path);
  } else {
    next();
  }
});
